export default __webpack_public_path__ + "static/media/fornite-logo3.6000e278.png";